import React from 'react';
import { Box, Text, TextButton } from '@wix/design-system';
import { useTranslation } from '../../../Infra';
import { StyledHeader } from './BaseSuccessPage';
export const EmailSaleSuccessPageHeaderContent = ({ variant, goLiveDate, email, siteName, siteDomain, viewSiteLink }) => {
    const { t, Trans, locale } = useTranslation();
    const goLiveDateString = goLiveDate.toLocaleDateString(locale, {
        month: 'short',
        day: 'numeric',
    });
    switch (variant) {
        case 'goingLive':
            return (React.createElement(StyledHeader, { title: t('domains_shared_components.connecting.success_page.title', {
                    siteName,
                    domainName: siteDomain,
                }), body: React.createElement(Text, null,
                    React.createElement(Trans, { i18nKey: 'domains_shared_components.connect.success_page.process.description', values: { userEmail: email, connectDate: goLiveDateString }, components: [React.createElement("b", null)] })) }));
        case 'inProgress':
            return (React.createElement(StyledHeader, { title: t('entri.modal.white_label.congratulations.title'), body: React.createElement(Box, { direction: 'vertical', gap: 'SP2' },
                    React.createElement(Text, null,
                        React.createElement(Trans, { i18nKey: 'domains_shared_components.connect_manual.success_page.description', values: { domainName: siteDomain }, components: [React.createElement("b", null)] })),
                    React.createElement(Text, null,
                        React.createElement(Trans, { i18nKey: 'domains_shared_components.connect.success_page.dates.description', values: {
                                connectWeekDay: goLiveDate.toLocaleDateString(locale, {
                                    weekday: 'long',
                                }),
                                connectMonthDay: goLiveDateString,
                            }, components: [React.createElement("b", null)] }))) }));
        case 'connected':
        default:
            return (React.createElement(StyledHeader, { title: t('my-domains-shared-components.new.assign_success.title', {
                    domainName: siteDomain,
                    siteName,
                }), body: React.createElement(Text, null,
                    t('my-domains-shared-components.status.assign_success.already_published'),
                    ' ',
                    React.createElement(TextButton, { underline: 'always', skin: 'dark', as: 'a', href: viewSiteLink }, t('my-domains-shared-components.status.assign_success.view_site'))) }));
    }
};
//# sourceMappingURL=EmailSaleSuccessPageHeaderContent.js.map